export function ToPlainText(text: string): string {
  if (typeof text !== 'string') {
    return text;
  }

  if (!text) {
    return '';
  }

  const regex = /<.*?>/g;
  return text
    .replace(regex, '')
    .replace(/\&amp;/g, '&')
    .replace(/\&nbsp;/g, ' ')
    .replace(/\&gt;/g, '>')
    .replace(/\&lt;/g, '<');
}
